import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getActiveCampaigns } from '../services/api';
import useAuthStore from '../context/authStore';
import toast from 'react-hot-toast';
import './GlobalCampaignBar.css';

export default function GlobalCampaignBar() {
  const navigate = useNavigate();
  const { user, userDoc } = useAuthStore();
  const [campaign, setCampaign] = useState(null);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    getActiveCampaigns().then(r => {
      if (r.data && r.data.length > 0) {
        setCampaign(r.data[0]);
      }
    }).catch(() => {});
  }, []);

  if (!campaign || !isVisible) return null;

  return (
    <div className="global-campaign-bar">
      <div className="gcb-container">
        <div className="gcb-ticker">
          <span className="gcb-urgent">عاجل 🚨</span>
          <span className="gcb-text">
            {campaign.title}: خصم يصل إلى {campaign.discountType === 'percentage' ? `${campaign.discountValue}%` : `${campaign.discountValue} ج.م`} لفترة محدودة جداً!
          </span>
          <button className="gcb-cta" onClick={() => {
            if (!user) {
              toast.error('يجب تسجيل الدخول أولاً');
              return navigate('/login');
            }
            if (userDoc?.role !== 'student') {
              return toast.error('هذا العرض مخصص للطلاب');
            }
            navigate('/courses');
          }}>استفد بالعرض الآن ←</button>
        </div>
        <button className="gcb-close" onClick={() => setIsVisible(false)}>✕</button>
      </div>
    </div>
  );
}
